/**
 * Featured collection only: extends the theme Swiper web component so prev/next
 * can live in the section header while multiple tabbed carousels share one pair
 * of buttons (clicks target the visible .fc-wrapper carousel).
 */
(function () {
  var Base = window.SwiperComponent;
  if (!Base || customElements.get('featured-collection-swiper')) return;

  var registry = new WeakMap();

  function resolveNavRoot(host) {
    var sel = host.dataset.sharedNavigationRoot;
    if (!sel) return null;
    try {
      return document.querySelector(sel);
    } catch (e) {
      return null;
    }
  }

  function activeSwiperFromSet(swipeHosts) {
    var chosen = null;
    swipeHosts.forEach(function (host) {
      if (!host || !host.swiper) return;
      var panel = host.closest('.fc-wrapper');
      if (panel && !panel.classList.contains('d-none')) chosen = host.swiper;
    });
    if (chosen) return chosen;
    swipeHosts.forEach(function (host) {
      if (!chosen && host && host.swiper) chosen = host.swiper;
    });
    return chosen;
  }

  function ensureNavBindings(navRoot, host) {
    var entry = registry.get(navRoot);
    if (!entry) {
      entry = { swipers: new Set(), prevHandler: null, nextHandler: null };
      registry.set(navRoot, entry);
    }
    entry.swipers.add(host);

    if (entry.prevHandler || !navRoot) return;

    var prev = navRoot.querySelector('.swiper-button-prev');
    var next = navRoot.querySelector('.swiper-button-next');

    entry.prevHandler = function (e) {
      e.preventDefault();
      var ent = registry.get(navRoot);
      if (!ent) return;
      var swiper = activeSwiperFromSet(ent.swipers);
      if (swiper && typeof swiper.slidePrev === 'function') swiper.slidePrev();
    };
    entry.nextHandler = function (e) {
      e.preventDefault();
      var ent = registry.get(navRoot);
      if (!ent) return;
      var swiper = activeSwiperFromSet(ent.swipers);
      if (swiper && typeof swiper.slideNext === 'function') swiper.slideNext();
    };

    if (prev) prev.addEventListener('click', entry.prevHandler);
    if (next) next.addEventListener('click', entry.nextHandler);
  }

  function releaseNavBindings(navRoot, host) {
    var entry = registry.get(navRoot);
    if (!entry) return;
    entry.swipers.delete(host);
    if (entry.swipers.size === 0 && entry.prevHandler) {
      var prev = navRoot.querySelector('.swiper-button-prev');
      var next = navRoot.querySelector('.swiper-button-next');
      if (prev) prev.removeEventListener('click', entry.prevHandler);
      if (next) next.removeEventListener('click', entry.nextHandler);
      registry.delete(navRoot);
    }
  }

  class FeaturedCollectionSwiper extends Base {
    findControl(selector) {
      if (
        this.dataset.sharedNavigationRoot &&
        (selector === '.swiper-button-prev' || selector === '.swiper-button-next')
      ) {
        return null;
      }
      return super.findControl(selector);
    }

    initSwiper() {
      super.initSwiper();
      var navRoot = resolveNavRoot(this);
      if (navRoot && (this.showArrows || this.showArrowsOnMobile)) {
        ensureNavBindings(navRoot, this);
      }
    }

    disconnectedCallback() {
      var navRoot = resolveNavRoot(this);
      if (navRoot) releaseNavBindings(navRoot, this);
      super.disconnectedCallback();
    }
  }

  window.FeaturedCollectionSwiper = FeaturedCollectionSwiper;
  customElements.define('featured-collection-swiper', FeaturedCollectionSwiper);

  function refreshFeaturedSwipers(root) {
    if (!root || typeof root.querySelectorAll !== 'function') return;
    root.querySelectorAll('featured-collection-swiper').forEach(function (el) {
      if (typeof el.refresh === 'function') el.refresh();
    });
  }

  document.addEventListener('shopify:section:load', function (e) {
    refreshFeaturedSwipers(e.target);
  });

  var refreshWithin = function (e) {
    var root = e.target;
    if (!root || typeof root.querySelectorAll !== 'function') return;
    var host = root.closest ? root.closest('featured-collection-swiper') : null;
    if (host && typeof host.refresh === 'function') host.refresh();
    refreshFeaturedSwipers(root);
  };
  document.addEventListener('shopify:section:select', refreshWithin);
  document.addEventListener('shopify:block:select', refreshWithin);
})();
